import type { Glob } from '../utils/types'

export const globs = import.meta.glob<Glob>('./**/*.md', {
	eager: true,
})

export const globByFullPathname = new Map<string, Glob>()
for (let [pathname, module] of Object.entries(globs)) {
	pathname = pathname.substring(2, pathname.length - 3)

	globByFullPathname.set(pathname, module)
}